import React from "react"

export const withUseStyles = (Component, useStyles) => (props) => {
  const classes = useStyles()
  return <Component {...{ ...props, classes }} />
}
